import { render, staticRenderFns } from "./modalBuscarPedidos.vue?vue&type=template&id=2db6327c"
import script from "./modalBuscarPedidos.vue?vue&type=script&lang=js"
export * from "./modalBuscarPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports